import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import Button from 'components/Button';
import { CloseIcon } from 'components/Icons';
import styled from 'styled-components/macro';
import { theme } from 'styled-tools';

const DeleteAction = styled.div`
  color: ${theme('colors.darkRed')};
  text-align: center;
  font-size: 0.875rem;
  padding: 1.5rem 0;

  span:hover {
    cursor: pointer;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;

  ${Button} {
    &:first-child {
      margin-right: 0.5rem;
    }

    &:last-child {
      margin-left: 0.5rem;
    }
  }
`;

const Message = styled.p`
  text-align: center;
`;

function DeleteModal({ title, message, action, buttonLabel, className }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <DeleteAction className={className}>
      <span onClick={toggle}>
        <CloseIcon />
        {title}
      </span>
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalBody>
          <Message>{message}</Message>
          <ButtonWrapper>
            <Button kind='tertiary' onClick={toggle}>
              Cancel
            </Button>
            <Button kind='primary' onClick={action}>
              {buttonLabel}
            </Button>
          </ButtonWrapper>
        </ModalBody>
      </Modal>
    </DeleteAction>
  );
}

DeleteModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.element,
  buttonLabel: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default React.memo(DeleteModal);
